module.exports = __webpack_public_path__ + "media/Bootes.f76c90cf.ogg";